module.exports = __webpack_public_path__ + "img/bicicleta.afecd08b.png";